// removed by extract-text-webpack-plugin
module.exports = {"container":"layouts-main-container","header":"layouts-main-header","visible":"layouts-main-visible","content":"layouts-main-content","footer":"layouts-main-footer","stickyHeader":"layouts-main-stickyHeader"};


//////////////////
// WEBPACK FOOTER
// ./styles/layouts/main.scss
// module id = 780
// module chunks = 246